import _ from "lodash"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../hooks/hooks";
import { SubscriptionCard } from "./subscription-card";
import { selectAssistanceProgramsListItems } from "../../../redux/assistance-programs/selector";
import { assistancePrograms } from "../../../redux/assistance-programs/action";


export const Subscriptions = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch()
    const [programPlan, setProgramPlan] = useState<any>([]);
    const itemsData = useSelector(selectAssistanceProgramsListItems)

    useEffect(() => {
        dispatch(assistancePrograms.list({
            url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/assistance-programs/list`, entity: 'assistancePrograms', jsonData: {
            }
        }))
    }, [])
    useEffect(() => {
        setProgramPlan(itemsData?.result?.items);
    }, [itemsData]);

    const subscribe = (item: any) => {
        navigate(`${item?.Id}`)
    }
    return (
        <>
            <div className="bg-[#f0f4f8] px-4 py-16 min-h-screen">

                <div className="max-w-7xl mx-auto px-6 md:px-12 xl:px-6">
                    <div className="mb-10 space-y-4 px-6 md:px-0">
                        <h2 className="text-center text-2xl font-bold text-gray-800 sm:text-3xl md:text-4xl">Subscriptions</h2>

                    </div>
                    <div className="grid xl:grid-cols-3 sm:grid-cols-4 grid-cols-2 gap-8 mb-[46px]">
                        {programPlan && _.map(programPlan, (item: any) => (
                            <SubscriptionCard subscription={item} subscribe={subscribe} />
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}